import { StyleSheet, View } from 'react-native';

import { IconButton } from '../index';
import type { useTheme } from './theme';

// The roster's fixed slot (PE-22 fetta E): «Add exercise», and #356's «More
// time» beside it, same box, on a session a model wrote. Outer edges full,
// shared inner edges given up: the idiom SupersetTabs and CuePill already use
// for a tight row. The chips carry a hitSlop of 8 too, and ChipStrip's gap is
// what the zones meet on.
export function RosterLeadingActions({
  onAddExercise,
  onMoreTime,
  t,
  theme,
}: {
  onAddExercise: () => void;
  /** Absent: no button. */
  onMoreTime?: () => void;
  t: (k: string, opts?: Record<string, unknown>) => string;
  theme: ReturnType<typeof useTheme>;
}) {
  const add = (
    <IconButton
      theme={theme}
      name="plus"
      onPress={onAddExercise}
      // 36 + 8 on the left still clears the 44pt floor.
      hitSlop={{ top: 8, bottom: 8, left: 8, right: 0 }}
      accessibilityLabel={t('mobile.logger.addExercise', { defaultValue: 'Add exercise' })}
    />
  );
  if (!onMoreTime) return add;
  return (
    <View style={[styles.row, { gap: theme.spacing.s3 }]}>
      {add}
      <IconButton
        theme={theme}
        name="clock-plus"
        onPress={onMoreTime}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 0 }}
        accessibilityLabel={t('mobile.logger.moreTime.title', { defaultValue: 'More time' })}
      />
    </View>
  );
}

const styles = StyleSheet.create({ row: { flexDirection: 'row' } });
